import { createApp } from 'vue';
import App from './App.vue';

import '@/assets/main.css';

import gsapPlugin from './plugins/gsap';

import { fadeUp } from '@/directives/fadeUp.js';
import { bounceIn } from '@/directives/bounceIn.js';

import Vue3Lottie from 'vue3-lottie';

import { createGtm } from '@gtm-support/vue-gtm';

const app = createApp(App);

const gtmId = process.env.VUE_APP_GTM_ID;
if (gtmId) {
    const gmt = createGtm({
        id: process.env.VUE_APP_GTM_ID,
        loadScript: true,
        defer: true,
    });
    app.use(gmt);
}

app.use(gsapPlugin);
app.use(Vue3Lottie);
app.directive('fade-up', fadeUp);
app.directive('bounce-in', bounceIn);
app.mount('#app');
